/*
 * @Author: youthscc(蒋松)
 * @Date: 2024-05-22 15:34:39
 * @LastEditors: youthscc(蒋松)
 * @LastEditTime: 2024-05-23 16:37:29
 * @Description:
 */
import $BindMobile from '../data/bindMobileOrEmail'
import { i18n } from 'app-core/lib/i18n'
export default {
  created() {
    // 如果sessionStorage没有值的话就初始化存入
    if (JSON.parse(window.sessionStorage.getItem('showReminder')) === null) {
      window.sessionStorage.setItem('showReminder', 1)
    }
    this.getMyinfoCheckSwitch()
  },

  methods: {
    getMyInfoCheckContent(res) {
      console.log('res', res)
      let checkRes = false
      let content = ''
      if (
        res.data.code === '0' &&
        res.data.data &&
        res.data.data.showReminder &&
        !!JSON.parse(window.sessionStorage.getItem('showReminder'))
      ) {
        checkRes = true
        content = res.data.data.alertMsg
      }
      return [checkRes, content]
    },
    /**
     * 获取是否需要同步手机号、姓名等字段的开关
     * 单点登录 开关 是否是客服 登录人是否有手机号
     * @returns {Promise<void>}
     */
    // async getMobileCheckSwitch() {
    async getMyinfoCheckSwitch() {
      const that = this
      const res = await $BindMobile.userCompletionReminder() // 更换验证信息接口
      const [checkRes, content] = this.getMyInfoCheckContent(res)
      if (checkRes) {
        this.$w.confirm.show({
          title: i18n.t('APP_HOME.9_I_8PA2C_N3_O9_P1_KN1_DD_XU'),
          content: content,
          confirmText: i18n.t('APP_HOME.LM_MWS3FU_FT_LI_N8J8CSU_W'),
          cancelText: i18n.t('APP_HOME.CN_D8_P_ZAAP_EE1_OS3S6B3V'),
          hideOnBlur: false,
          onConfirm() {
            that.$router.push({
              path: '/common/myinformation'
            })
          },
          onCancel() {
            window.sessionStorage.setItem('showReminder', 0)
          }
        })
      }
    }
  }
}
